import { useEffect, useState, useRef } from "react";

import styles from "./setupPage.module.css";
import ImgBuilder from "../../assets/ImgBuilder";
import AppBar from "../../components/appBar/appBar";
import AbortGame from "../../components/abortGame/abortGame";

// due to separate development, 2 language systems were integrated to the app,
// currently they will work together, 1 for teen game and 1 for the other
// ideally 1 should be picked
import { useLanguage } from '../../functions/setGetLanguage';
import { renderWithLineBreaksAndBold } from '../../functions/renderWithLineBreaksAndBold';
import { useResetUserDataAndLanguage } from '../../functions/useResetUserDataAndLanguage';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const SetupPage = () => {
  // reset, as it might be an ending point of users to go back
  const resetUserDataAndLanguage = useResetUserDataAndLanguage();
  
  const hasReset = useRef(false);

  useEffect(() => {
    if (hasReset.current) return;
    hasReset.current = true;

    resetUserDataAndLanguage();
  }, [resetUserDataAndLanguage]);

  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  // const [languageI18n, setLanguageI18n] = useState(i18n.language || "en");
  const [isLoaded, setIsLoaded] = useState(false);

  // secong language implemenation (ideally should be 1)
  const { setLanguage } = useLanguage();

  useEffect(() => {
    const savedLang = localStorage.getItem("i18nextLng");
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
      // setLanguageI18n(savedLang);
      // // secong language implemenation (ideally should be 1)
      setLanguage(`_${savedLang}`)
    }
  }, [i18n, setLanguage]);

  const handleStartClick = () => {
    navigate("/login");
  };

  return (
    <div className={styles.wrapper}>
      <AppBar />
      <AbortGame />
      <div className={styles.container}>
        
        <div className={styles.imageContainer}>
          {!isLoaded && <div className={styles.loader}></div>}
          <img 
            src={ImgBuilder.logo}
            alt="Logo" 
            className={styles.logo}
            style={{
              opacity: isLoaded ? 1 : 0,
              transition: "opacity 0.2s ease-in-out",
            }}
            onLoad={() => setIsLoaded(true)}
          />
        </div>
        
        <div className={styles.breakingNews}>{t("setup.breaking_news")}</div>

        <p className={styles.mainText}>
          {renderWithLineBreaksAndBold(t("setup.description"))}
        </p>
      </div>
      <div className={styles.buttonsContainer}>
        <button onClick={handleStartClick} className={styles.button}>{t("setup.ready_confirmation")}</button>
      </div>
    </div>
  );
};

export default SetupPage;
